import { Component, EventEmitter, Output, OnInit,ElementRef,ViewEncapsulation } from '@angular/core';
import { Cookies } from '../../../class/cookies';
import { Service } from '../../../class/service';
import { Router } from '@angular/router';

declare var jQuery: any;

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MainMenuComponent implements OnInit {
  opened = false;
	elements = {
		master:[],
		childrens: []
	};
	views:Array<Object>;
	innerHTML:string;
	@Output() onOpened = new EventEmitter<boolean>();
	@Output() selectedView = new EventEmitter<string>();

  constructor(
    private router: Router, 
		private cookies:Cookies, 
		private service:Service,
		private _elRef:ElementRef
  ) { }

  ngOnInit() {
    this.open(false);
    let data = this.cookies.getCookie('ChamUserObject');
	this.service.POST('views',{id:data["id"]}).subscribe(res => {
		this.views = res["views"];
		this.innerHTML = "";
		this.LoadMenu();
	},err => { 
		console.log(err); 
	});
	jQuery(this._elRef.nativeElement).find("#main_menu_container").slimScroll({ height: '100%' });
  }

  private index = 0;
  private LoadMenu(){
		this.views.forEach(element => {
			if(element["index"] == ""){
				this.elements.master.push(element);
			}else{
				this.elements.childrens.push(element);
			}
		});
		this.innerHTML += "<ul>";
		this.elements.master.forEach(element =>{
			this.innerHTML += "<li>";
			
			this.innerHTML += "<a"+(element["have_child"] == "0" ? " data-route=\""+element["key"]+"\" " : "")+""+(parseInt(element["have_child"]) == 1 ? " class='have_child'" : "" )+">";
			if(element["icon"] != ""){
				this.innerHTML += "<div class='icon-left'><i class='fa "+element["icon"]+"' aria-hidden='true'></i></div>";
			}
			this.innerHTML += "<span class='text'>"+element["description"]+"</span>";
			if(parseInt(element["have_child"]) == 1){
				this.innerHTML += "<div class='icon-right'><i class='fa fa-chevron-down' aria-hidden='true'></i></div>";
			}
			this.innerHTML += "</a>";
			if(parseInt(element["have_child"]) == 1){
				this.innerHTML += this.masterd(this.elements.childrens,element["id"]);
			}
			this.innerHTML += "</li>"
		});
		this.innerHTML += "</ul>";
		jQuery(this._elRef.nativeElement).find("#main_menu_container").append(this.innerHTML);
		this.open(true);
		setTimeout(()=>{
			jQuery('#main_menu_container ul li').removeClass('open');
			jQuery(this._elRef.nativeElement).find("a.have_child").on("click", function(){
				var _hasClass = false;
				if(jQuery(this).parent().hasClass('open')){
					_hasClass = true;
				}
				jQuery(this).parent().parent().find("li").removeClass('open');
				if(_hasClass){
					jQuery(this).parent().removeClass('open');
				}else{
					jQuery(this).parent().addClass('open');
				}


			});

			
			jQuery(this._elRef.nativeElement).find("#main_menu_container ul li a").on("click", (event) => {
				var route = jQuery(event.currentTarget).data("route");
				var title = jQuery(event.currentTarget).find('.text').text();
				if(route != undefined){
					this.selectedView.emit(JSON.stringify({id: route,description: title}));
				}
			});

			
		});
	}
	
	private masterd(array:any,parent_id:number):string{
		let list = "";

		list += "<ul>";
		array.forEach(element => {
			if(parseInt(element["parent_id"]) == parent_id){
				list += "<li>";
				
				list += "<a"+(element["have_child"] == "0" ? " data-route=\""+element["key"]+"\" " : "")+" "+(parseInt(element["have_child"]) == 1 ? "class='have_child'": "")+">";
				if(element["icon"] != ""){
					list += "<div class='icon-left'><i class='fa "+element["icon"]+"' aria-hidden='true'></i></div>";
				}
			    list += "<span class='text'>"+element["description"]+"</span>";
				if(parseInt(element["have_child"]) == 1){
					list += "<div class='icon-right'><i class='fa fa-chevron-down' aria-hidden='true'></i></div>";
				}
				list += "</a>";
				if(parseInt(element["have_child"]) == 1){
					list += this.masterd(array, element["id"]);
				}
				list += "</li>";
			}
		});
		list += "</ul>";
		return list;
	}
	open(open: boolean){
		this.onOpened.emit(open);
		this.opened = open;
		setTimeout(()=>{
			jQuery('#main_menu_container ul li').removeClass('open');
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/component/module/main-menu/main-menu.component.ts